import React, { useState } from 'react';
import { Monitor, Box, Zap, ChevronRight } from 'lucide-react';
import { services } from '../data/mock';

const ServicesSection = ({ id }) => {
  const [activeTab, setActiveTab] = useState('digital');

  const serviceCategories = [
    {
      id: 'digital',
      title: 'Produtos Digitais',
      icon: <Monitor size={24} />,
      color: 'from-blue-500/20 to-purple-500/20',
      services: services.digital
    },
    {
      id: 'industrial',
      title: 'Produtos Industriais', 
      icon: <Box size={24} />,
      color: 'from-green-500/20 to-blue-500/20',
      services: services.industrial
    },
    {
      id: 'general',
      title: 'Serviços Gerais',
      icon: <Zap size={24} />,
      color: 'from-purple-500/20 to-pink-500/20',
      services: services.general
    }
  ];

  return (
    <section id={id} className="section-padding">
      <div className="container">
        {/* Section Header */}
        <div className="text-center mb-16 fade-in-up">
          <div className="inline-flex items-center gap-2 glass-card px-4 py-2 text-sm text-brand-primary border border-brand-primary/20 mb-6">
            <span>Nossos Serviços</span>
          </div>
          <h2 className="heading-1 mb-6">
            Soluções <span className="text-brand-primary">Completas</span>
          </h2>
          <div className="w-20 h-1 bg-brand-primary rounded-full mx-auto mb-8"></div>
          <p className="body-large max-w-3xl mx-auto">
            Da concepção à implementação, oferecemos serviços especializados 
            para transformar suas ideias em produtos excepcionais.
          </p>
        </div>

        {/* Services Tabs */}
        <div className="w-full">
          {/* Tab Navigation */}
          <div className="flex flex-col sm:flex-row glass-card p-3 mb-12 rounded-xl">
            {serviceCategories.map((category) => (
              <button
                key={category.id}
                onClick={() => setActiveTab(category.id)}
                className={`flex-1 flex items-center justify-center gap-2 px-4 py-4 mx-1 rounded-lg transition-all duration-300 font-semibold ${
                  activeTab === category.id
                    ? 'bg-brand-primary text-text-inverse shadow-xl border-2 border-brand-primary transform translate-y-[-2px]'
                    : 'text-text-secondary hover:text-brand-primary hover:bg-bg-card/50 border-2 border-transparent'
                }`}
              >
                <div className={`${activeTab === category.id ? 'scale-105' : ''} transition-transform duration-300`}>
                  {category.icon}
                </div>
                <span className="text-sm sm:text-base whitespace-nowrap">{category.title}</span>
              </button>
            ))}
          </div>

          {/* Tab Content */}
          {serviceCategories.map((category) => (
            activeTab === category.id && (
              <div key={category.id} className="animate-fadeIn">
                <div className="grid sm:grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
                  {category.services.map((service, index) => (
                    <div 
                      key={index}
                      className="glass-card p-6 group hover:border-brand-primary/30 transition-all duration-300"
                      style={{ animationDelay: `${index * 0.1}s` }}
                    >
                      <div className="flex items-start justify-between mb-4">
                        <div className="flex-1">
                          <h3 className="heading-3 text-lg mb-3 group-hover:text-brand-primary transition-colors">
                            {service.title}
                          </h3>
                          <p className="body-small text-text-secondary leading-relaxed">
                            {service.description}
                          </p>
                        </div>
                        <ChevronRight 
                          size={20} 
                          className="text-brand-primary opacity-0 group-hover:opacity-100 transition-all duration-300 transform group-hover:translate-x-1 mt-1 ml-2 flex-shrink-0" 
                        />
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            )
          ))}
        </div>

        {/* CTA Section */}
        <div className="text-center mt-16">
          <div className="glass-card p-8 max-w-2xl mx-auto">
            <h3 className="heading-2 text-2xl mb-4">
              Pronto para começar seu <span className="text-brand-primary">projeto</span>?
            </h3>
            <p className="body-medium mb-6">
              Entre em contato conosco e descubra como podemos transformar 
              suas ideias em realidade.
            </p>
            <button 
              onClick={() => {
                const element = document.getElementById('contact');
                if (element) {
                  element.scrollIntoView({ behavior: 'smooth' });
                }
              }}
              className="btn-primary"
            >
              Solicitar Orçamento
            </button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ServicesSection;